import React, { FC } from 'react';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import { UserBadgePrintStats } from '../../../shared/cashier';
import { DateTime } from '../../components';
import { useTranslation } from '../../translations';
import { Fetcher, renderName, useFetcher } from '../../utils';

export const PrintLogModal: FC<{
  readonly close: () => void;
  readonly userId: number;
}> = ({ close, userId }) => {
  const { ts } = useTranslation();

  return (
    <Modal
      className="modal-large cashier-settings-modal hide-print"
      fade={false}
      isOpen
      toggle={close}
    >
      <ModalHeader toggle={close}>{ts('user_print_log_modal_title')}</ModalHeader>
      <ModalBody>
        <PrintLogTable userId={userId} />
      </ModalBody>
    </Modal>
  );
};

const PrintLogRow: FC<{ readonly print: UserBadgePrintStats }> = ({ print }) => {
  const { ts } = useTranslation();

  const reason = print.reprint ? (
    (print.reason ?? ts('no_reason_given'))
  ) : (
    <i>{ts('initial_print')}</i>
  );

  return (
    <tr>
      <td>{renderName(print.cashier)}</td>
      <td>
        <DateTime value={print.createdAt} />
      </td>
      <td>{reason}</td>
    </tr>
  );
};

const PrintLogTable: FC<{ readonly userId: number }> = ({ userId }) => {
  const { ts } = useTranslation();

  const request = useFetcher(async () => {
    return await api.getBadgePrintsForUser(userId);
  });

  if (!request.success) {
    return <Fetcher result={request} />;
  }

  if (request.data.length === 0) {
    return <p>{ts('print_logs.no_prints')}</p>;
  }

  return (
    <Table id="print-log-table">
      <thead>
        <tr>
          <th>{ts('common.cashier')}</th>
          <th>{ts('common.date')}</th>
          <th>{ts('reason')}</th>
        </tr>
      </thead>
      <tbody>
        {request.data.map((print) => {
          return (
            <PrintLogRow key={`${print.userId}-${print.createdAt.toString()}`} print={print} />
          );
        })}
      </tbody>
    </Table>
  );
};
